import React, { useEffect } from "react";
import { Carousel } from "antd";
import { Link } from "react-router-dom";
import Vector4 from "../../assets/services/Vector4.png";
import six from "../../assets/6.png";
import Steps from "../Home/Steps";
import { useDispatch, useSelector } from "react-redux";
import { fetchCategories } from "../../redux/categoriesSlice";
import { useTranslation } from "react-i18next";

const Service = () => {
  const { t, i18n } = useTranslation();
  const { language } = i18n;

  const dispatch = useDispatch();
  const { categories, status, error } = useSelector(
    (state) => state.categories
  );

  useEffect(() => {
    if (status === "idle") {
      dispatch(fetchCategories());
    }
  }, [status, dispatch]);

  return (
    <div className="mt-24 max-lg:mt-20 px-20 max-lg:px-5 Service relative" id="bookService">
      <div className="">
        <h2 className="text-[#14294F] text-3xl max-lg:text-xl font-semibold">
          {t("service.samoolahServices")}
        </h2>
        <p className="text-[#737E91] text-lg mt-3 w-3/5 max-lg:w-full">
        {t("mainServices.learnOurServices")}
        </p>
      </div>

      <Carousel arrows infinite={false} className="relative z-0">
        {categories.map((category, index) => (
          <div key={index} dir={language == "en" ? "ltr" : "rtl"}>
            <div className="grid grid-cols-3 max-lg:grid-cols-1 gap-10 lg:px-20 mt-10 max-lg:mt-5 lg:items-center">
              <div className="lg:col-span-2 lg:pl-10">
                <h3 className="text-[#283D63] text-2xl max-lg:text-xl max-lg:text-center font-semibold">
                  {language == "en" ? category.name_en : category.name}
                </h3>
                <p className="text-[#737E91] text-lg mt-3">
                {language === "en" ? category.desc_en : category.desc}
                </p>
                <div className="grid grid-cols-3 max-lg:grid-cols-1 gap-4 mt-7">
                  {category.sub_category.map((subcategory, index) => (
                    <div key={index} className="bg-[#F9FBFC] text-[#7092C9] border-2 border-[#7092C9] text-center rounded-full text-xl py-3">
                      {language === "en" ? subcategory.name_en : subcategory.name_ar}
                    </div>
                  ))}
                </div>
              </div>
              <div>
                <img
                  src={`https://service.samoolah.com/${category.icon}`}
                  className="w-[180px] mx-auto"
                />
              </div>
            </div>

            <div className="flex justify-center items-center text-center mt-14">
              <Link
                to={`/services/${category.id}`}
                className="text-[#FE9B71] rounded-full border-4 border-[#FE9B71] w-[250px] h-[55px] text-xl flex items-center justify-center font-semibold mx-auto"
              >
                {t("service.bookServiceNow")}
              </Link>
            </div>
          </div>
        ))}
      </Carousel>

      <img
        src={Vector4}
        className="w-[250px] max-lg:hidden absolute left-56 top-1/3 z-10 mt-2"
      />

      <div className="mt-56 max-lg:mt-20 max-lg:hidden">
        <Steps />
      </div>
    </div>
  );
};

export default Service;